<template>
  <div>
    <SerialPack :url="url" cur-class="one_plus_six_collect" />
  </div>
</template>

<script>
import SerialPack from '@/views/config/activity-auxiliary/superCollectPack.vue'
export default {
  name: 'OnePlusSixCollect',
  components: {
    SerialPack
  },
  data() {
    return {
      url: '/config/activity-auxiliary/onePlusSixCollect'
    }
  }
}
</script>

<style scoped>

</style>
